import { create } from 'zustand';

// Flash Sale缓存数据接口
interface FlashSaleCacheState {
  recommendList: any[];
  waterfallPosition: number;
  allRecommendListLoaded: boolean;

  // Actions
  setCache: (
    data: Partial<Omit<FlashSaleCacheState, 'setCache' | 'getCache' | 'clearCache'>>,
  ) => void;
  clearCache: () => void;
}

// 创建Flash Sale专用的缓存store（本地store，不需要集成到全局）
export const useFlashSaleCache = create<FlashSaleCacheState>((set) => ({
  // 初始状态
  recommendList: [],
  waterfallPosition: 0,
  allRecommendListLoaded: false,

  // 设置缓存
  setCache: (data) =>
    set((state) => ({
      ...state,
      ...data,
    })),

  // 清除缓存
  clearCache: () =>
    set({
      recommendList: [],
      waterfallPosition: 0,
      allRecommendListLoaded: false,
    }),
}));

// 页面刷新时清除缓存
if (typeof window !== 'undefined') {
  try {
    const perfData = window.performance.getEntriesByType(
      'navigation',
    )[0] as PerformanceNavigationTiming;
    if (perfData?.type === 'reload') {
      // 重置store状态
      useFlashSaleCache.setState({
        recommendList: [],
        waterfallPosition: 0,
        allRecommendListLoaded: false,
      });
    }
  } catch {
    // 忽略错误
  }
}
